import { Menu } from 'react-admin';
import { Divider, Box, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import PsychologyIcon from '@mui/icons-material/Psychology';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ArticleIcon from '@mui/icons-material/Article';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NotificationsIcon from '@mui/icons-material/Notifications';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import QueueIcon from '@mui/icons-material/Queue';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { ExpandableMenuItem } from './ExpandableMenuItem';
import { NestedMenuItem } from './NestedMenuItem';

const emptyFn = () => {};

export const AdminMenu = () => (
  <Menu>
    {/* Application Workflow */}
    <Box sx={{ px: 2, py: 1 }}>
      <Typography
        variant="caption"
        sx={{
          textTransform: 'uppercase',
          fontWeight: 600,
          color: 'text.secondary',
          letterSpacing: '0.5px',
        }}
      >
        Application Workflow
      </Typography>
    </Box>
    <ExpandableMenuItem
      primaryText="Therapists"
      leftIcon={<PeopleIcon />}
      to="/therapists"
    >
      {/* <NestedMenuItem
        to="/conversionMonitor"
        primaryText="Conversion"
        leftIcon={<AttachMoneyIcon />}
        title="Conversion"
      /> */}
      <NestedMenuItem
        to="/therapistPatients"
        primaryText="Clients"
        leftIcon={<PersonIcon />}
        title="Clients"
      />
    </ExpandableMenuItem>
    <Menu.Item
      to="/therapistSessionNotes"
      primaryText="Session Notes"
      leftIcon={<AssignmentIcon />}
      title="Session Notes"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <ExpandableMenuItem
      primaryText="Document Composer"
      leftIcon={<FactCheckIcon />}
      to="/documentComposerRulesets"
    >
      <NestedMenuItem
        to="/documentComposerRulesets"
        primaryText="Rulesets"
        leftIcon={<FactCheckIcon />}
        title="Rulesets"
      />
      <NestedMenuItem
        to="/documentComposerSkills"
        primaryText="Skills"
        leftIcon={<ListAltIcon />}
        title="Document Composer Skills"
      />
    </ExpandableMenuItem>
    <Menu.Item
      to="/therapistHomework"
      primaryText="Homework"
      leftIcon={<SchoolIcon />}
      title="Homework"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/appTrackerEvents"
      primaryText="App Events Tracker"
      leftIcon={<TrackChangesIcon />}
      title="App Events Tracker"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/dataExports"
      primaryText="Data Exports"
      leftIcon={<CloudDownloadIcon />}
      title="Data Exports"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />

    <Box sx={{ my: 1 }}>
      <Divider />
    </Box>

    {/* Configuration */}
    <Box sx={{ px: 2, py: 1 }}>
      <Typography
        variant="caption"
        sx={{
          textTransform: 'uppercase',
          fontWeight: 600,
          color: 'text.secondary',
          letterSpacing: '0.5px',
        }}
      >
        Configuration
      </Typography>
    </Box>
    <Menu.Item
      to="/therapist-app-admin"
      primaryText="App Config"
      leftIcon={<SettingsIcon />}
      title="App Config"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/therapistSessionNotesFrameworks"
      primaryText="Notes Frameworks"
      leftIcon={<DescriptionIcon />}
      title="Notes Frameworks"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/llmModels"
      primaryText="Models"
      leftIcon={<PsychologyIcon />}
      title="Models"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/aiPrompts"
      primaryText="Agent Prompts"
      leftIcon={<PsychologyIcon />}
      title="Agent Prompts"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/aiPromptTags"
      primaryText="Prompt Tags"
      leftIcon={<LocalOfferIcon />}
      title="Prompt Tags"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />

    <Box sx={{ my: 1 }}>
      <Divider />
    </Box>

    {/* App Content */}
    <Box sx={{ px: 2, py: 1 }}>
      <Typography
        variant="caption"
        sx={{
          textTransform: 'uppercase',
          fontWeight: 600,
          color: 'text.secondary',
          letterSpacing: '0.5px',
        }}
      >
        App Content
      </Typography>
    </Box>
    <Menu.Item
      to="/appDocuments"
      primaryText="App Documents"
      leftIcon={<ArticleIcon />}
      title="App Documents"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/appGlobalAlerts"
      primaryText="Global Alerts"
      leftIcon={<NotificationsIcon />}
      title="Global Alerts"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />

    <Box sx={{ my: 1 }}>
      <Divider />
    </Box>

    {/* System & Operations */}
    <Box sx={{ px: 2, py: 1 }}>
      <Typography
        variant="caption"
        sx={{
          textTransform: 'uppercase',
          fontWeight: 600,
          color: 'text.secondary',
          letterSpacing: '0.5px',
        }}
      >
        System & Operations
      </Typography>
    </Box>
    <Menu.Item
      to="/userMetadata"
      primaryText="Administrators"
      leftIcon={<AdminPanelSettingsIcon />}
      title="Administrators"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/deadLetterQueue"
      primaryText="Dead Letter Queue"
      leftIcon={<QueueIcon />}
      title="Dead Letter Queue"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
    <Menu.Item
      to="/reports"
      primaryText="Investigation Reports"
      leftIcon={<AssessmentIcon />}
      title="Investigation Reports"
      onPointerEnterCapture={emptyFn}
      onPointerLeaveCapture={emptyFn}
    />
  </Menu>
);
